import { type TableName } from '../types'

interface NavItem {
  id: TableName
  icon: string
  label: string
  badge?: string
}

const NAV_ITEMS: NavItem[] = [
  { id: 'institutions', icon: '🏛️', label: 'Institutions' },
  { id: 'menu_categories', icon: '📂', label: 'Menu Categories' },
  { id: 'menu_items', icon: '📋', label: 'Menu Items' },
  { id: 'notices', icon: '📢', label: 'Notices' },
  { id: 'teachers_staff', icon: '👩‍🏫', label: 'Teachers & Staff' },
  { id: 'important_links', icon: '🔗', label: 'Important Links' },
  { id: 'gallery', icon: '🖼️', label: 'Gallery' },
  { id: 'quick_buttons', icon: '⚡', label: 'Quick Buttons' },
  { id: 'student_stats', icon: '📊', label: 'Student Stats' },
]

interface SidebarProps {
  activeTab: TableName
  onTabChange: (tab: TableName) => void
  eiin: string
}

export default function Sidebar({ activeTab, onTabChange, eiin }: SidebarProps) {
  return (
    <aside style={{
      width: '230px',
      flexShrink: 0,
      background: '#fff',
      borderRadius: '16px',
      padding: '20px 14px',
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
      border: '1px solid #fed7aa',
      boxShadow: '0 10px 30px rgba(234, 88, 12, 0.05)'
    }}>
      {/* Header */}
      <div style={{ padding: '4px 8px 16px', borderBottom: '1px solid #ffedd5', marginBottom: '8px' }}>
        <div style={{ fontSize: '11px', fontWeight: 800, color: '#f97316', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>
          Navigation Menu
        </div>
        <div style={{ fontSize: '14px', fontWeight: 800, color: '#1c1917' }}>
          FGC Web Admin
        </div>
        <div style={{
          marginTop: '8px',
          display: 'inline-block',
          background: '#fff7ed',
          border: '1px solid #ffedd5',
          color: '#ea580c',
          fontSize: '11px',
          fontWeight: 700,
          padding: '3px 10px',
          borderRadius: '6px'
        }}>
          EIIN: {eiin}
        </div>
      </div>

      {/* Nav Items */}
      {NAV_ITEMS.map((item, idx) => {
        const isActive = activeTab === item.id
        return (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '10px 14px',
              width: '100%',
              textAlign: 'left',
              background: isActive
                ? 'linear-gradient(135deg, #ffedd5 0%, #fff7ed 100%)'
                : 'transparent',
              border: isActive
                ? '1px solid #fdba74'
                : '1px solid transparent',
              borderRadius: '10px',
              color: isActive ? '#c2410c' : '#44403c',
              fontWeight: isActive ? 800 : 600,
              fontSize: '13.5px',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              boxShadow: isActive ? '0 2px 8px rgba(234,88,12,0.1)' : 'none'
            }}
          >
            <span style={{ fontSize: '17px' }}>{item.icon}</span>
            <span style={{ flex: 1 }}>
              <span style={{ fontSize: '11px', color: isActive ? '#ea580c' : '#a8a29e', marginRight: '6px' }}>
                {idx + 1}.
              </span>
              {item.label}
            </span>
            {isActive && <span style={{ fontSize: '12px', color: '#ea580c' }}>●</span>}
          </button>
        )
      })}

      {/* D1 badge */}
      <div style={{
        marginTop: 'auto',
        paddingTop: '16px',
        borderTop: '1px solid #ffedd5',
        textAlign: 'center',
        fontSize: '12px',
        color: '#9a3412',
        fontWeight: 700
      }}>
        ☁️ Database
      </div>
    </aside>
  )
}
